


























































import { Vue, Prop, Component } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import AppDialog from '@core/components/AppDialog.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import ILPPortfolioV2, { Fund } from '@master/model/kyc-form/ILPPortfolioV2'
import { cloneDeep } from 'lodash/fp'

import { ProductMeta } from '@master/model/common/ProductMeta'
import { BasicProductV2 } from '@master/model/kyc-form/product/BasicProductV2'

@Component({
  components: {
    AppForm,
    RecycleScroller,
    AppDialog
  }
})

export default class TheILPDetails extends Vue {
  @Prop() inputModel: ILPPortfolioV2
  @Prop() rcmdIlpProducts: BasicProductV2[]
  @Prop({ default: false }) isEditMode: boolean
  @Prop() ilpFundList: ProductMeta[]
  @Prop({ default: 8 }) maxFundsToAdd: number

  @inject()
  private sharedVariable: SharedVariable

  uiService: UIService

  private portfolioModel: ILPPortfolioV2 = new ILPPortfolioV2();
  private fundSelectionDialog = false
  private searchText = ''
  private selectedFundIndex = undefined
  private readonly fundNumber = 8

  get portfolioStructure (): FormStructure<ILPPortfolioV2> {
    return [
      {
        label: 'Product Name',
        key: 'oid',
        options: this.rcmdIlpProducts.map(prod => {
          return {
            label: prod.productName,
            value: prod.oid
          }
        }),
        onChange: (oldVal, newVal) => {
          const selectedProduct = this.rcmdIlpProducts.find(product => product.oid === newVal)
          this.portfolioModel.name = selectedProduct?.productName
          this.portfolioModel.issuerOid = selectedProduct?.issuerOid
          this.portfolioModel.rcmdReferenceId = selectedProduct?.referenceId
        }
      }
    ]
  }

  get fundStructure (): FormStructure<Fund> {
    return [
      {
        label: 'Investment Amount ($)',
        key: 'invAmt',
        type: 'currency'
      }
    ]
  }

  get fundList () {
    const list = this.ilpFundList.filter(product => product.issuer_oid === this.portfolioModel.issuerOid)
    if (this.searchText.length === 0) {
      return list
    }
    return list.filter(search => {
      return search.name.toLowerCase().includes(this.searchText.toLowerCase())
    })
  }

  portfolioFundOnClick (fundIndex) {
    this.selectedFundIndex = fundIndex
    this.fundSelectionDialog = true
  }

  deleteFund (index) {
    this.portfolioModel.funds.splice(index, 1)
  }

  addFund () {
    const newFund: Fund =
    {
      name: '',
      invAmt: 0,
      frequency: '',
      paymentMode: '',
      for: '',
      choice: ''
    }
    this.portfolioModel.funds.push(newFund)
  }

  selectRecommendedFund (fundName) {
    this.portfolioModel.funds[this.selectedFundIndex].name = fundName
    this.fundSelectionDialog = false
  }

  saveChanges () {
    if (!this.portfolioModel.oid || this.portfolioModel.oid === '') {
      this.uiService.alert.show({
        type: 'error',
        message: 'Please key in valid product name.'
      })
      return
    }
    this.$emit('saveProduct', this.portfolioModel)
  }

  hideModal () {
    this.$emit('close')
  }

  mounted () {
    this.uiService = this.sharedVariable.uiService
    // populates the model with the first ilp rcmd product, if any
    // this is done because on ipad the fund list does not get populated by default
    if (this.rcmdIlpProducts?.length > 0) {
      this.portfolioModel.name = this.rcmdIlpProducts[0].productName
      this.portfolioModel.issuerOid = this.rcmdIlpProducts[0].issuerOid
      this.portfolioModel.rcmdReferenceId = this.rcmdIlpProducts[0].referenceId
    }
  }

  created () {
    if (this.inputModel) {
      this.portfolioModel = cloneDeep(this.inputModel)
    } else {
      this.portfolioModel = new ILPPortfolioV2()
    }
  }
}

